import { HttpResult } from "widgets-for-react";
import { FacebookTrackEventObject, FacebookTrackEventResponse } from "./models/FacebookTrackEventObject";

// client/src/helpers.ts
export type MouseClickEvent<T> = MouseEvent & { target: T }

export type Option<T> = { kind: 'none' } | { kind: 'some'; value: T }

export function Option<T>(value: T): Option<T> {
  if (!value) return { kind: 'none' }

  return {
    kind: 'some',
    value: value
  }
}

export function toRelativeUrl(url: string): string {
  url = removeInternationalKeywordFromUrl(url)
  let relative: string = url.replace(`${window.location.protocol}//`, '')
  return relative.indexOf('/') > 0 ? relative.substr(relative.indexOf('/')) : relative
}

export function decodeHTMLEntities(html: string): string {
  let output: Element = document.createElement('div')
  output.innerHTML = html
  return output.textContent.replace(/&amp;/g, '&')
}

export type ViewPortSize = 'mobile' | 'tablet' | 'desktop'

export function resizeImage(url: string, width: number, height: number): string {
  // Implement resize
  return url
}

export type gtmHash<T> = { [key: string]: T }

type gtmType = {
  event?: string
  category?: string
  label?: string
  action?: string
  menu_type?: string 
  click_text?: string
  cta_type?: string
  expandable_click?: 'open' | 'close'
  link_list_click?: 'yes' | 'no'
  interaction?: string
  language?: string
  results?: 'yes' | 'no'
  number_of_results?: number
  search_term?: string
  filter_subject?: string 
  filter_search?: string 
  filter_selection?: string
}

export async function gtmPush(data: gtmType) {
  let defaultData: gtmHash<string> = {

  }

  if (window.dataLayer) {
    window.dataLayer.push({ ...defaultData, ...data });
  } else {
    console.log({ ...defaultData, ...data });
  }

  await trackEvent({
    data: [
      {
        event_name: 'event.frieslandcampina_institute', 
        action_source: 'website', 
        event_time: Math.floor(new Date().getTime() / 1000),
        event_id: 'event.frieslandcampina_institute', 
        event_source_url: window.location.href, 
        user_data: {
          client_user_agent: window.navigator.userAgent, 
        }
      }
    ]
  })
}

export async function optimizeActivate() {
  let defaultData: gtmHash<string> = {
    event: 'optimize.activate'
  }

  if (window.dataLayer) {
    window.dataLayer.push({ ...defaultData });
  } else {
    console.log({ ...defaultData });
  }

  await trackEvent({
    data: [
      {
        event_name: 'optimize.activate',
        action_source: 'website',
        event_time: Math.floor(new Date().getTime() / 1000),
        event_id: 'optimize.activate',
        event_source_url: window.location.href,
        user_data: {
          client_user_agent: window.navigator.userAgent
        },
      }
    ]
  })
}

export function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}

export function createCookie(name, value, days): void {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

export function getCookie(c_name: string): string {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}


export const trackEvent = async (body: FacebookTrackEventObject): Promise<HttpResult<FacebookTrackEventResponse>> => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let external_id = getCookie("external_id")
  if (external_id == "") {
    external_id = getRandomInt(1000, 9999999).toString()
    createCookie("external_id", external_id, 365)
  }

  body.data.forEach(v => {
    v.user_data.external_id = external_id
  })

  return await fetch("/api/v1/facebook/track_event", {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(body),
    redirect: 'follow'
  })
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      return Promise.reject(response.status)
    })
    .then(result => <HttpResult<FacebookTrackEventResponse>>({ kind: 'result', status: 200, value: result }))
    .catch(error => <HttpResult<FacebookTrackEventResponse>>({ kind: 'failed', status: error }));
}

export function removeInternationalKeywordFromUrl(url: string): string {
  const urlParts = url.split("/");
  let a = 3 
  let b = 4
  if (!url.startsWith("https://") && !url.startsWith("http://") ) {
    a -= 2 
    b -= 2
  }
  if (urlParts[a] === "international") {
    let s = urlParts.slice(0, a)
    let e = urlParts.slice(b, urlParts.length)
    return s.concat(e).join("/");
  }
  return url;
}

export function mapLanguage (lang: string): string {
  if (lang == '') {
    return "international"
  }
  return lang
}